export const explorerMap = {
  ETH: 'https://etherscan.io/address/', // 1
  OP: 'https://optimistic.etherscan.io/address/', // 10
  BSC: 'https://bscscan.com/address/', // 56
  OEC: 'https://www.oklink.com/en/okc/tokenAddr/', // 66
  HSC: 'https://hooscan.com/tx/', // 70
  HECO: 'https://hecoinfo.com/address/', // 128
  MATIC: 'https://polygonscan.com/address/', // 137
  FTM: 'https://ftmscan.com/address/', // 250
  KCC: 'https://scan.kcc.io/tx/', // 321
  CFX: 'https://evm.confluxscan.net/address/', // 1030
  GLMR: 'https://moonscan.io/tx/', // 1284
  KLAY: 'https://scope.klaytn.com/account/', // 8217
  ARB: 'https://arbiscan.io/address/', // 42161
  AVAX: 'https://snowtrace.io/address/', // 43114
  TRON: 'https://tronscan.io/#/address/', // 95500
}
export const chainIdMap = {
  ETH: 1, // 1
  BSC: 12, // 56
  OEC: 20, // 66
  HECO: 15, // 128
  MATIC: 18, // 137
  FTM: 25, // 250
  ARB: 24, // 42161
  AVAX: 23, // 43114
}
export const chainIdMainnetMap = {
  ETH: 1, // 1
  BSC: 56, // 56
  OEC: 66, // 66
  HECO: 128, // 128
  MATIC: 137, // 137
  FTM: 250, // 250
  ARB: 42161, // 42161
  AVAX: 43114, // 43114
}

export const statusNotesMap = {
  wait_deposit_send: 'wait_deposit_send(等待存币)',
  wait_exchange_push: 'wait_exchange_push(正在兑换中)',
  wait_exchange_return: 'wait_exchange_return(正在兑换中)',
  wait_exchange_return_success: 'wait_exchange_return_success(正在兑换中)',
  wait_exchange_return_error: 'wait_exchange_return_error(正在兑换中)',
  wait_receive_send: 'wait_receive_send(兑换完成，等待发币)',
  wait_receive_confirm: 'wait_receive_confirm(正在发币中)',
  wait_receive_confirm_error: 'wait_receive_confirm_error(正在发币中)',
  wait_refund_send: 'wait_refund_send(等待退币)',
  wait_refund_confirm: 'wait_refund_confirm(退币确认中)',
  wait_refund_confirm_error: 'wait_refund_confirm_error(退币中)',
  refund_complete: 'refund_complete(退币完成)',
  Confirming: 'Confirming(兑换完成，等待发币)',
  Swapping: 'Swapping(正在发币中)',
  'BigAmount(Wait24hours)': 'BigAmount(Wait24hours)(大额兑换，需要等待)',
  wait_deposit_send_error: '存幣失敗',
  timeout: '兌換超時',
  ERROR: '兌換失敗，訂單有誤',
  error_hacker: '兌換失敗，訂單有誤',
  'ExceedLimit(LessThenMinAmount)': '低於兌換限額',
  // Failure: '兌換失敗，訂單有誤',
}
